import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { AutocompleteState, BaseItem } from '@algolia/autocomplete-core';

interface Props {
	state: AutocompleteState<BaseItem>;
}

export const ProgramsHeader: React.FC<Props> = ({ state }) => {
	return (
		<>
			<div className='aa-SourceHeaderTitle'>
				<Typography variant='label1'>Top results for {state.query}</Typography>
			</div>
			<div className='aa-SourceHeaderLine' />
		</>
	);
};
